/**
 * Navigation Module
 *
 * Mobile menu toggle and scroll-driven header behavior.
 */
export class Navigation {
    constructor(selector) {
        this.header = document.querySelector('.site-header');
        this.toggle = document.querySelector('.menu-toggle');
        this.mobileNav = document.querySelector('.mobile-nav');
        this.overlay = document.querySelector('.menu-overlay');
        this.init();
    }

    init() {
        if (this.toggle && this.mobileNav) {
            this.toggle.addEventListener('click', () => this.toggleMenu());
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.closeMenu());
        }

        // Close on link click (only for non-submenu trigger links)
        if (this.mobileNav) {
            this.mobileNav.addEventListener('click', (e) => {
                const link = e.target.closest('a');
                if (!link) return;

                const parentLi = link.parentElement;
                const hasChildren = parentLi.classList.contains('menu-item-has-children');

                if (hasChildren && window.innerWidth <= 992) {
                    // It's a mobile submenu trigger
                    e.preventDefault();
                    parentLi.classList.toggle('is-active');
                } else if (link.matches('a')) {
                    this.closeMenu();
                }
            });
        }

        // Handle Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.mobileNav.classList.contains('is-open')) {
                this.closeMenu();
            }
        });
    }

    toggleMenu() {
        const isOpen = this.mobileNav.classList.toggle('is-open');
        this.overlay.classList.toggle('is-visible', isOpen);
        document.body.classList.toggle('menu-open', isOpen);
        this.toggle.setAttribute('aria-expanded', String(isOpen));
    }

    closeMenu() {
        this.mobileNav.classList.remove('is-open');
        this.overlay.classList.remove('is-visible');
        document.body.classList.remove('menu-open');
        this.toggle.setAttribute('aria-expanded', 'false');
    }
}
